import { useQuery } from '@tanstack/react-query'
import { SpendTimeseries, getSpendTimeseries } from 'api/pulse/spendTimeseries'
import { PulseFilters } from 'api/pulse'
import { getSpendTimeseriesKey } from './keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useSpendTimeseries(query: PulseFilters) {
  return useQuery<SpendTimeseries>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getSpendTimeseriesKey(query),
    queryFn: ({ signal }) => getSpendTimeseries(query, signal),
    enabled: !!query.companyIds?.length,
  })
}
